export enum SelectionValues {
    color = 'color',
    size = 'size',
    sizeShoes = 'sizeShoes',
    brand = 'brand',
    condition = 'state',
    shop = 'webShop',
    fit = 'catalogClothingFit',
}
